<template>
  <el-dialog :visible.sync="show" :fullscreen="true" :show-close="false" v-loading="loading" custom-class="mcd">
    <div slot="title">
      <el-button size="mini" icon="el-icon-setting" class="mcd-setting" @click="openConditionDialog" type="primary">设置条件</el-button>
      <el-radio-group size="mini" class="mcd-escape" v-model="escape">
        <el-radio-button :label="true">转义</el-radio-button>
        <el-radio-button :label="false">不转义</el-radio-button>
      </el-radio-group>
      图形化建模
      <el-button size="mini" icon="el-icon-upload" class="mcd-save" @click="toSave" type="primary">保 存</el-button>
      <el-button size="mini" icon="el-icon-circle-close" class="mcd-close" @click="show = false">退 出</el-button>
    </div>
    <el-row>
      <el-col :span="6">
        <div class="mcd-meta-table" v-loading="loading1">
          <el-select v-model="rdbDataSourceId" placeholder="请选择数据源" title="数据源" @change="loadDataSourceMetadata">
            <el-option v-for="db in rdbDataSources" :key="db.rdbDataSourceId" :label="db.name" :value="db.rdbDataSourceId">
              <template v-if="db.desc">
                {{ db.name }}<span class="mcd-option-desc">{{db.type}} - {{ db.desc }} ({{db.projectName}} - {{db.systemName}})</span>
              </template>
              <template v-else>
                {{ db.name }}<span class="mcd-option-desc">{{db.type}} ({{db.projectName}} - {{db.systemName}})</span>
              </template>
            </el-option>
          </el-select>
          <p v-for="metaTable in metaTables" :key="metaTable.name" @click="selectMetaTable(metaTable)" :class="getMetaTableClass(metaTable)" title="表">
            <span>{{metaTable.name}}</span>
            <span>{{metaTable.cmt}}</span>
          </p>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="mcd-design-preview" title="SQL预览区域">
          <div v-html="html"></div>
          <p v-if="!html">SQL预览区域</p>
        </div>
        <div class="mcd-design-area" id="mcd-design-area" title="表设计区域">
          <div v-for="metaTable in tables" :key="metaTable.name" class="mcd-design-table" :style="'top:' + metaTable.top + ';left:' + metaTable.left" :id="'mcd_' + metaTable.name" @dblclick="onTableDoubleClick(metaTable)">{{metaTable.name}}</div>
        </div>
        <div class="mcd-design-column" title="字段选择区域">
          <el-table :data="metaColumns" @selection-change="onColumnChange" ref="columnTable" :stripe="true" size="mini" empty-text="请先选择表 或 为已选择的表建立关联">
            <el-table-column type="selection" width="32"></el-table-column>
            <el-table-column prop="table" label="表"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="alias" label="别名">
              <template slot-scope="scope">
                <el-input placeholder="请输入别名" v-model="scope.row.alias" size="mini" @change="calc"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="cmt" label="注释" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="dataType" label="数据类型"></el-table-column>
            <el-table-column prop="dataLength" label="长度"></el-table-column>
            <el-table-column prop="dataScale" label="精度">
              <template slot-scope="scope">
                <span v-if="scope.row.dataScale">{{scope.row.dataScale}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="nullable" label="可否为空">
              <template slot-scope="scope">
                <span v-if="scope.row.nullable">可以</span>
                <span v-else>不可</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="编辑表别名" :visible.sync="showTableAliasForm" append-to-body>
      <el-form :status-icon="true" label-position="top">
        <el-form-item label="表名">
          <el-input v-model="tableAliasForm.name" readonly></el-input>
        </el-form-item>
        <el-form-item label="别名">
          <el-input v-model="tableAliasForm.alias" placeholder="请输入表的别名"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="showTableAliasForm = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="doSaveTableAlias">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑连接" :visible.sync="showJoinDialog" append-to-body>
      <div class="mcd-connection-type">
        <div style="text-align:left">
          <label>{{join.table1}}</label>
          <el-select v-model="join.field1" placeholder="请选择关联字段" size="mini">
            <el-option v-for="metaColumn in metaTableColumns[join.table1]" :key="metaColumn.name" :value="metaColumn.name">
              {{ metaColumn.name }}<span class="mcd-option-desc">{{metaColumn.dataType}} - {{ metaColumn.cmt }}</span>
            </el-option>
          </el-select>
        </div>
        <div style="text-align:center;margin:30px auto;">
          <el-radio-group v-model="join.type" size="mini">
            <el-radio-button label="左">左连接</el-radio-button>
            <el-radio-button label="右">右连接</el-radio-button>
            <el-radio-button label="内">内连接</el-radio-button>
            <el-radio-button label="外" v-if="rdbDataSource.type !== 'MYSQL'">外连接</el-radio-button>
          </el-radio-group>
        </div>
        <div style="text-align:right">
          <label>{{join.table2}}</label>
          <el-select v-model="join.field2" placeholder="请选择关联字段" size="mini">
            <el-option v-for="metaColumn in metaTableColumns[join.table2]" :key="metaColumn.name" :value="metaColumn.name">
              {{ metaColumn.name }}<span class="mcd-option-desc">{{metaColumn.dataType}} - {{ metaColumn.cmt }}</span>
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="showJoinDialog = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="changeConnectionType">保 存</el-button>
      </div>
    </el-dialog>

    <gui-condition-dialog ref="conditionDialog" @change="onConditionChange"></gui-condition-dialog>

    <el-dialog title="保存模型" :visible.sync="showForm" append-to-body>
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true" label-position="top">
        <el-form-item label="模型名称" prop="name" size="mini">
          <el-input v-model="form.name" placeholder="请输入模型名称"></el-input>
        </el-form-item>
        <el-form-item label="访问控制类型" prop="acType" size="mini">
          <el-radio-group v-model="form.acType">
            <el-radio-button :label="acType.key" v-for="acType in acTypes" :key="acType.key">{{acType.label}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="数据类型" prop="type">
          <el-radio-group v-model="form.type" size="mini">
            <el-radio-button label="OBJECT">单条数据</el-radio-button>
            <el-radio-button label="LIST">列表</el-radio-button>
            <el-radio-button label="PAGE">分页</el-radio-button>
            <el-radio-button label="FIELD">单个字段</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="form.desc" placeholder="请填写模型描述" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="showForm = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="doSave(false)">保 存</el-button>
        <el-button size="mini" type="primary" @click="doSave(true)">保存并退出</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { acTypes } from '@/config'
import GuiConditionDialog from './GuiConditionDialog'

const seq = '       '

function getRdbDataSource (rdbDataSources, rdbDataSourceId) {
  if (!rdbDataSources || !rdbDataSources.length || !rdbDataSourceId) {
    return {}
  }
  for (let rdbDataSource of rdbDataSources) {
    if (rdbDataSource.rdbDataSourceId === rdbDataSourceId) {
      return rdbDataSource
    }
  }
  return {}
}

function getAllConnections (table, jsPlumb) {
  let connections = []
  getConnections(jsPlumb.getEndpoint('mcd_' + table + '_right'), connections, jsPlumb)
  return connections
}

function getConnections (rightEndpoint, result, jsPlumb) {
  let connections = rightEndpoint.connections
  if (!connections || !connections.length) {
    return
  }

  result.push(connections[0])

  let leftEndpoint
  let endpoints = connections[0].endpoints
  if (endpoints[0] === rightEndpoint) {
    leftEndpoint = endpoints[1]
  } else {
    leftEndpoint = endpoints[0]
  }

  getConnections(jsPlumb.getEndpoint(leftEndpoint.anchor.elementId + '_right'), result, jsPlumb)
}

function getTable (table, connection) {
  let table1 = connection.source.innerText
  let table2 = connection.target.innerText
  if (table1 === table) {
    return table2
  }
  if (table2 === table) {
    return table1
  }
  return null
}

export default {
  name: 'gui-config-dialog',
  components: {
    GuiConditionDialog
  },
  data () {
    return {
      acTypes: acTypes,
      jsPlumb: null,
      initing: false,
      show: false,
      loading: false,
      rdbDataSources: [],
      rdbDataSourceId: null,
      rdbDataSource: {},
      model: {},
      loading1: false,
      metaTables: [],
      metaColumns: [],
      metaTableColumns: {},
      tableAliasMap: {},
      showTableAliasForm: false,
      tableAliasForm: {},
      showJoinDialog: false,
      join: {
        doing: false,
        connection: null,
        table1: '',
        field1: '',
        type: '',
        table2: '',
        field2: ''
      },
      tables: [],
      conditions: [],
      escape: true,
      sql: '',
      html: '',
      showForm: false,
      form: {
        name: '',
        acType: '',
        type: '',
        desc: ''
      },
      formRule: {
        name: [{ required: true, message: '请输入模型名称', trigger: 'blur' }],
        acType: [{ required: true, message: '请选择访问控制类型', trigger: 'change' }],
        type: [{ required: true, message: '请选择数据类型', trigger: 'change' }]
      }
    }
  },
  watch: {
    model (model) {
      this.rdbDataSourceId = model.dataSourceId || null
      this.form = { name: model.name, acType: model.acType, type: model.type, desc: model.desc }
      this.loadDataSourceMetadata()
    },
    rdbDataSources () {
      this.rdbDataSource = getRdbDataSource(this.rdbDataSources, this.rdbDataSourceId)
    },
    rdbDataSourceId () {
      this.rdbDataSource = getRdbDataSource(this.rdbDataSources, this.rdbDataSourceId)
    },
    metaTables () {
      let metaTableColumns = {}
      for (let metaTable of this.metaTables) {
        let tableName = metaTable.name
        let metaColumns = metaTable.metaColumns || []
        for (let metaColumn of metaColumns) {
          metaColumn.table = tableName
        }
        metaTableColumns[tableName] = metaColumns
      }
      this.metaTableColumns = metaTableColumns

      let configJson = this.model.config
      if (configJson) {
        let config = JSON.parse(configJson)

        let tables = []
        let tableAliasMap = {}
        let tempTables = config.tables
        for (let tempTable of tempTables) {
          for (let metaTable of this.metaTables) {
            if (tempTable.name === metaTable.name) {
              metaTable.top = tempTable.top
              metaTable.left = tempTable.left
              tables.push(metaTable)
              tableAliasMap[metaTable.name] = tempTable.alias
              break
            }
          }
        }
        this.tables = tables
        this.tableAliasMap = tableAliasMap

        this.$nextTick(() => {
          this.paint()

          let connections = config.connections
          if (connections && connections.length) {
            this.join.doing = true
            for (let connection of connections) {
              let temp = []
              let overlays = connection.overlays
              if (overlays.arrow1) {
                temp.push(['Arrow', {id: 'arrow1', location: 1, length: 20}])
              }
              if (overlays.arrow2) {
                temp.push(['Arrow', {id: 'arrow2', location: 0, length: 20, direction: -1}])
              }
              temp.push(['Label', {id: 'label', label: overlays.label, cssClass: 'mcd-design-label'}])

              this.jsPlumb.connect({
                source: this.jsPlumb.getEndpoint(connection.source),
                target: this.jsPlumb.getEndpoint(connection.target),
                overlays: temp
              })
            }
            this.join.doing = false
          }

          this.initing = true
          this.conditions = config.conditions || []
          this.buildMetaColumns()
          this.$nextTick(() => {
            let metaColumns = this.metaColumns
            for (let tempTable of tempTables) {
              let tableName = tempTable.name
              let columns = tempTable.columns || []
              for (let column of columns) {
                for (let metaColumn of metaColumns) {
                  if (metaColumn.table === tableName && column.name === metaColumn.name) {
                    metaColumn.alias = column.alias
                    this.$refs.columnTable.toggleRowSelection(metaColumn)
                  }
                }
              }
            }
            this.initing = false
            this.calc()
          })
        })
      } else {
        this.jsPlumb.reset()
        this.metaColumns = []
        this.tableAliasMap = {}
        this.tables = []
        this.conditions = []
      }
    },
    metaColumns () {
      this.calc()
    },
    escape () {
      this.calc()
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      this.jsPlumb = window.jsPlumb.getInstance({
        EndpointHoverStyle: { fill: '#0000FF' },
        EndpointStyle: { fill: 'rgba(30,144,255,0.9)'  },
        Endpoint: ['Dot', { radius: 8 }],
        Anchors: ['LeftMiddle', 'RightMiddle'],
        Container: 'mcd-design-area'
      })
    })
  },
  methods: {
    open (model) {
      if (!model) {
        this.model = {}
        this.show = true
      } else {
        this.show = true
        this.loadModel(model)
      }

      this.$http.request({
        method: 'get',
        url: '/api/cgRdbDataSources'
      }).then((res) => {
        this.rdbDataSources = res.data.data || []
      })
    },
    loadModel (model) {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgModels/${model.modelId}`
      }).then((res) => {
        this.model = res.data.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    loadDataSourceMetadata () {
      if (!this.rdbDataSourceId) {
        this.metaTables = []
        return
      }

      this.loading1 = true
      this.$http.request({
        method: 'get',
        url: `/api/cgRdbDataSources/${this.rdbDataSourceId}/metadata`
      }).then((res) => {
        this.metaTables = res.data.data || []
        this.loading1 = false
      }).catch(() => {
        this.loading1 = false
      })
    },
    selectMetaTable (metaTable) {
      let tables = this.tables
      let index = -1
      for (let i = 0; i < tables.length; i++) {
        if (tables[i].name === metaTable.name) {
          index = i
          break
        }
      }
      if (index === -1) {
        tables.push(metaTable)
      } else {
        tables.splice(index, 1)
      }

      let tableAliasMap = {}
      for (let table of tables) {
        tableAliasMap[table.name] = this.tableAliasMap[table.name]
      }
      this.tableAliasMap = tableAliasMap

      let countOfRow = Math.floor(document.getElementById('mcd-design-area').clientWidth / 220)
      for (let i = 0; i < tables.length; i++) {
        let row = Math.ceil((i + 1) / countOfRow)
        tables[i].top = ((row - 1) * 80 + 60) + 'px'
        tables[i].left = ((i % countOfRow) * 220 + 60) + 'px'
      }

      this.metaColumns = tables.length === 1 ? tables[0].metaColumns : []

      this.$nextTick(() => {
        this.paint()
      })
    },
    getMetaTableClass (metaTable) {
      let tables = this.tables
      for (let table of tables) {
        if (table.name === metaTable.name) {
          return 'active'
        }
      }
      return ''
    },
    paint () {
      let me = this
      let instance = me.jsPlumb

      instance.reset()
      instance.batch(() => {
        instance.bind('connection', (info) => {
          if (!me.join.doing) {
            me.openJoinDialog(info.connection)
          }
        })
        instance.bind('connectionDetached', (info) => {
          if (!me.join.doing) {
            me.buildMetaColumns(info.connection)
          }
        })
        instance.bind('connectionMoved', (info) => {
          if (info.connection.getOverlays().label) {
            info.connection.removeOverlay('label')
          }
        })
        instance.bind('click', (connection) => {
          me.openJoinDialog(connection)
        })

        let endpoint = {
          scope: 'table',
          isSource: true,
          isTarget: true,
          connectorStyle: { stroke: '#1E90FF', strokeWidth: 8 },
          connectorHoverStyle: { stroke: '#0000FF' },
          connector: 'Straight',
          beforeDrop: function (param) {
            if (param.sourceId === param.targetId) {
              return false
            }

            let isMove = false
            let cs = me.jsPlumb.getAllConnections()
            let connection = param.connection
            if (cs.length + 1 === me.tables.length) {
              for (let c of cs) {
                if (c === connection) {
                  isMove = true
                  break
                }
              }
              if (!isMove) {
                return false
              }
            }

            let temp = param.sourceId + param.targetId
            for (let c of cs) {
              if (c !== connection && (temp === c.sourceId + c.targetId || temp === c.targetId + c.sourceId)) {
                return false
              }
            }

            return true
          }
        }

        for (let i = 0; i < me.tables.length; i++) {
          let table = me.tables[i]
          let id = 'mcd_' + table.name
          if (i === 0) {
            instance.addEndpoint(id, { uuid: id + '_right', anchor: 'RightMiddle' }, endpoint)
          } else {
            instance.addEndpoint(id, { uuid: id + '_left', anchor: 'LeftMiddle' }, endpoint)
            instance.addEndpoint(id, { uuid: id + '_right', anchor: 'RightMiddle' }, endpoint)
          }
        }

        instance.draggable(window.jsPlumb.getSelector('.mcd-design-table'), { containment: 'parent' })
      })
    },
    onTableDoubleClick (metaTable) {
      this.tableAliasForm = { name: metaTable.name, alias: this.tableAliasMap[metaTable.name] }
      this.showTableAliasForm = true
    },
    doSaveTableAlias () {
      this.tableAliasMap[this.tableAliasForm.name] = this.tableAliasForm.alias
      this.showTableAliasForm = false
      this.calc()
    },
    openJoinDialog (connection) {
      let join
      let table1 = connection.source.innerText
      let table2 = connection.target.innerText
      let overlays = connection.getOverlays() || {}
      for (let overlayId in overlays) {
        if (overlays[overlayId].type === 'Label') {
          let label = overlays[overlayId].label
          if (label) {
            let temp = label.split(seq)
            join = {
              doing: false,
              table1: table1,
              field1: temp[0],
              type: temp[1],
              table2: table2,
              field2: temp[2],
              connection: connection
            }
          }
          break
        }
      }
      this.join = join || {doing: false, table1: table1, field1: '', type: '左', table2: table2, field2: '', connection: connection}
      this.showJoinDialog = true
    },
    changeConnectionType () {
      let join = this.join
      if (!join.field1 || !join.field2) {
        alert('请选择关联字段')
        return
      }

      let connection = join.connection
      let source = connection.endpoints[0]
      let target = connection.endpoints[1]
      this.join.doing = true
      this.join.connection = null

      this.jsPlumb.deleteConnection(connection)

      let overlays
      let joinType = join.type
      if (joinType === '左') {
        overlays = [
          ['Arrow', {id: 'arrow1', location: 1, length: 20}]
        ]
      } else if (joinType === '右') {
        overlays = [
          ['Arrow', {id: 'arrow2', location: 0, length: 20, direction: -1}]
        ]
      } else if (joinType === '内') {
        overlays = [
          ['Arrow', {id: 'arrow1', location: 1, length: 20}],
          ['Arrow', {id: 'arrow2', location: 0, length: 20, direction: -1}]
        ]
      } else if (joinType === '外') {
        overlays = [
          ['Arrow', {id: 'arrow1', location: 1, length: 20}],
          ['Arrow', {id: 'arrow2', location: 0, length: 20, direction: -1}]
        ]
      }
      overlays.push(['Label', {id: 'label', label: `${join.field1}${seq}${joinType}${seq}${join.field2}`, cssClass: 'mcd-design-label'}])

      this.jsPlumb.connect({
        source: source,
        target: target,
        overlays: overlays
      })

      this.buildMetaColumns()

      this.join.doing = false
      this.showJoinDialog = false
    },
    buildMetaColumns (deletingConnection) {
      let connections = []
      let cs = this.jsPlumb.getAllConnections()
      for (let c of cs) {
        if (c === deletingConnection) {
          continue
        }
        connections.push(c)
      }

      let metaColumns = []
      let tables = this.tables
      if (connections.length + 1 === tables.length) {
        let joined = true
        for (let connection of connections) {
          if (!connection.getOverlays().label) {
            joined = false
            break
          }
        }

        if (joined) {
          for (let table of tables) {
            let cs = table.metaColumns || []
            for (let c of cs) {
              metaColumns.push(c)
            }
          }
        }
      }
      this.metaColumns = metaColumns
    },
    onColumnChange () {
      if (this.metaColumns && this.metaColumns.length) {
        this.calc()
      }
    },
    openConditionDialog () {
      if (!this.metaTables.length) {
        alert('请先选择数据源')
        return
      }
      if (!this.metaColumns.length) {
        alert('请先选择表 或 为已选择的表建立关联')
        return
      }
      this.$refs.conditionDialog.open(this.tables, this.conditions || [])
    },
    onConditionChange (conditions) {
      this.conditions = conditions
      this.calc()
    },
    calc () {
      if (this.initing) {
        return
      }

      let aliasMap = {}
      let tableAliasMap = this.tableAliasMap
      for (let tableName in tableAliasMap) {
        let alias = tableAliasMap[tableName] || tableName
        if (aliasMap[alias]) {
          this.$message.error(`表的别名${alias}冲突`)
          this.sql = ''
          this.html = ''
          return
        }
        aliasMap[alias] = true
      }

      let columns = this.metaColumns
      if (columns && columns.length > 0) {
        let selection = !this.$refs.columnTable ? [] : this.$refs.columnTable.selection
        if (selection && selection.length > 0) {
          columns = selection
        }
      }
      if (!columns || !columns.length) {
        this.sql = ''
        this.html = ''
        return
      }

      aliasMap = {}
      for (let column of columns) {
        let alias = column.alias || `${column.table}_${column.name}`
        if (aliasMap[alias]) {
          this.$message.error(`列的别名${alias}冲突`)
          this.sql = ''
          this.html = ''
          return
        }
        aliasMap[alias] = true
        column.alias = alias
      }

      let leftEscapeChar = ''
      let rightEscapeChar = ''
      if (this.escape) {
        if (this.rdbDataSource.type === 'MYSQL') {
          leftEscapeChar = '`'
          rightEscapeChar = '`'
        } else if (this.rdbDataSource.type === 'ORACLE') {
          leftEscapeChar = '"'
          rightEscapeChar = '"'
        } else if (this.rdbDataSource.type === 'SQL_SERVER') {
          leftEscapeChar = '['
          rightEscapeChar = ']'
        }
      }

      let sql = 'SELECT '
      let html = '<span>SELECT</span> '
      for (let column of columns) {
        let tableAlias = tableAliasMap[column.table] || column.table
        sql += `${leftEscapeChar}${tableAlias}${rightEscapeChar}.${leftEscapeChar}${column.name}${rightEscapeChar} AS ${leftEscapeChar}${column.alias}${rightEscapeChar},`
        html += `${leftEscapeChar}${tableAlias}${rightEscapeChar}.${leftEscapeChar}${column.name}${rightEscapeChar} <span>AS</span> ${leftEscapeChar}${column.alias}${rightEscapeChar},`
      }
      sql = sql.substring(0, sql.length - 1) + ' FROM '
      html = html.substring(0, html.length - 1) + ' <span>FROM</span> '

      let table2 = this.tables[0].name
      let alias2 = tableAliasMap[table2] || table2
      sql += `${leftEscapeChar}${table2}${rightEscapeChar} ${leftEscapeChar}${alias2}${rightEscapeChar}`
      html += `${leftEscapeChar}${table2}${rightEscapeChar} ${leftEscapeChar}${alias2}${rightEscapeChar}`

      if (this.tables.length > 1) {
        let connections = getAllConnections(table2, this.jsPlumb)
        for (let i = 0; i < connections.length; i++) {
          let connection = connections[i]
          let table1 = table2
          let alias1 = tableAliasMap[table1] || table1
          table2 = getTable(table1, connection)
          alias2 = tableAliasMap[table2] || table2

          let temp = connection.getOverlays().label.label.split(seq)
          let joinType = temp[1]
          if (joinType === '左') {
            sql += ` LEFT JOIN ${leftEscapeChar}${table2}${rightEscapeChar} ${leftEscapeChar}${alias2}${rightEscapeChar} ON ${leftEscapeChar}${alias1}${rightEscapeChar}.${leftEscapeChar}${temp[0]}${rightEscapeChar}=${leftEscapeChar}${alias2}${rightEscapeChar}.${leftEscapeChar}${temp[2]}${rightEscapeChar}`
            html += ` <span>LEFT</span> <span>JOIN</span> ${leftEscapeChar}${table2}${rightEscapeChar} ${leftEscapeChar}${alias2}${rightEscapeChar} <span>ON</span> ${leftEscapeChar}${alias1}${rightEscapeChar}.${leftEscapeChar}${temp[0]}${rightEscapeChar}<span>=</span>${leftEscapeChar}${alias2}${rightEscapeChar}.${leftEscapeChar}${temp[2]}${rightEscapeChar}`
          } else if (joinType === '右') {
            sql += ` RIGHT JOIN ${leftEscapeChar}${table2}${rightEscapeChar} ${leftEscapeChar}${alias2}${rightEscapeChar} ON ${leftEscapeChar}${alias1}${rightEscapeChar}.${leftEscapeChar}${temp[0]}${rightEscapeChar}=${leftEscapeChar}${alias2}${rightEscapeChar}.${leftEscapeChar}${temp[2]}${rightEscapeChar}`
            html += ` <span>RIGHT</span> <span>JOIN</span> ${leftEscapeChar}${table2}${rightEscapeChar} ${leftEscapeChar}${alias2}${rightEscapeChar} <span>ON</span> ${leftEscapeChar}${alias1}${rightEscapeChar}.${leftEscapeChar}${temp[0]}${rightEscapeChar}<span>=</span>${leftEscapeChar}${alias2}${rightEscapeChar}.${leftEscapeChar}${temp[2]}${rightEscapeChar}`
          } else if (joinType === '内') {
            sql += ` INNER JOIN ${leftEscapeChar}${table2}${rightEscapeChar} ${leftEscapeChar}${alias2}${rightEscapeChar} ON ${leftEscapeChar}${alias1}${rightEscapeChar}.${leftEscapeChar}${temp[0]}${rightEscapeChar}=${leftEscapeChar}${alias2}${rightEscapeChar}.${leftEscapeChar}${temp[2]}${rightEscapeChar}`
            html += ` <span>INNER</span> <span>JOIN</span> ${leftEscapeChar}${table2}${rightEscapeChar} ${leftEscapeChar}${alias2}${rightEscapeChar} <span>ON</span> ${leftEscapeChar}${alias1}${rightEscapeChar}.${leftEscapeChar}${temp[0]}${rightEscapeChar}<span>=</span>${leftEscapeChar}${alias2}${rightEscapeChar}.${leftEscapeChar}${temp[2]}${rightEscapeChar}`
          } else if (joinType === '外') {
            sql += ` OUTER JOIN ${leftEscapeChar}${table2}${rightEscapeChar} ${leftEscapeChar}${alias2}${rightEscapeChar} ON ${leftEscapeChar}${alias1}${rightEscapeChar}.${leftEscapeChar}${temp[0]}${rightEscapeChar}=${leftEscapeChar}${alias2}${rightEscapeChar}.${leftEscapeChar}${temp[2]}${rightEscapeChar}`
            html += ` <span>OUTER</span> <span>JOIN</span> ${leftEscapeChar}${table2}${rightEscapeChar} ${leftEscapeChar}${alias2}${rightEscapeChar} <span>ON</span> ${leftEscapeChar}${alias1}${rightEscapeChar}.${leftEscapeChar}${temp[0]}${rightEscapeChar}<span>=</span>${leftEscapeChar}${alias2}${rightEscapeChar}.${leftEscapeChar}${temp[2]}${rightEscapeChar}`
          }
        }
      }

      let condition = this.$refs.conditionDialog.getSql(this.conditions, this.tableAliasMap, leftEscapeChar, rightEscapeChar)
      if (condition.sql && condition.html) {
        sql += ` WHERE ${condition.sql}`
        html += ` <span>WHERE</span> ${condition.html}`
      }

      this.sql = sql
      this.html = html
    },
    toSave () {
      if (!this.sql || !this.html) {
        alert('请先完成配置')
        return
      }
      this.showForm = true
    },
    doSave (exit) {
      if (!this.sql || !this.html) {
        alert('请先完成配置')
        return
      }

      this.$refs.form.validate((success) => {
        if (!success) {
          return false
        }

        let tempTables = []
        for (let table of this.tables) {
          let el = this.jsPlumb.getEndpoint(`mcd_${table.name}_right`).getElement()
          tempTables.push({
            name: table.name,
            alias: this.tableAliasMap[table.name],
            top: el.offsetTop + 'px',
            left: el.offsetLeft + 'px',
            columns: []
          })
        }

        let columns = this.$refs.columnTable.selection
        if (!columns || !columns.length) {
          columns = this.metaColumns
        }
        for (let column of columns) {
          for (let table of tempTables) {
            if (table.name === column.table) {
              table.columns.push({
                name: column.name,
                alias: column.alias,
                cmt: column.cmt
              })
            }
          }
        }

        let connections = []
        let cs = this.jsPlumb.getAllConnections()
        for (let c of cs) {
          let overlays = c.getOverlays()
          connections.push({
            source: c.endpoints[0].getUuid(),
            target: c.endpoints[1].getUuid(),
            overlays: {
              label: overlays.label.label,
              arrow1: overlays.arrow1 ? true : false,
              arrow2: overlays.arrow2 ? true : false,
            }
          })
        }

        let modelId = this.model.modelId
        this.$http.request({
          method: !modelId ? 'post' : 'put',
          url: !modelId ? '/api/cgModels' : `/api/cgModels/${modelId}`,
          data: JSON.stringify({
            dataSourceId: this.rdbDataSourceId,
            name: this.form.name,
            acType: this.form.acType,
            type: this.form.type,
            desc: this.form.desc,
            sql: this.sql,
            buildType: 'GUI',
            config: JSON.stringify({
              tables: tempTables,
              conditions: this.conditions,
              connections: connections
            })
          })
        }).then((res) => {
          this.model = res.data.data
          this.showForm = false
          if (exit) {
            this.show = false
          }
          this.$emit('save', this.model)
        })
      })
    }
  }
}
</script>

<style lang='less'>
.mcd{
  .el-dialog__header{
    padding:15px 0;
    border-bottom:1px solid #ebeef5;
    >div{
      position:relative;
      text-align:center;
      height:28px;
      line-height:28px;
    }
  }
  .el-dialog__body{padding:0;}
}
.mcd-setting{position:absolute;top:0;left:10px;line-height:26px;padding:0 15px;}
.mcd-escape{position:absolute;top:0;left:118px;}
.mcd-save{position:absolute;top:0;right:96px;line-height:26px;padding:0 15px;}
.mcd-close{position:absolute;top:0;right:10px;line-height:26px;padding:0 15px;}
.mcd-option-desc{color:#8492a6;font-size:12px;margin-left:20px}

.mcd-meta-table{width:100%;user-select:none;}
.mcd-meta-table>.el-select{display:block;margin:10px;}
.mcd-meta-table>p{border-radius:4px;border:1px solid #ebeef5;margin:10px;padding:6px;text-align:center;cursor:pointer;}
.mcd-meta-table>p.active{background:aliceblue}
.mcd-meta-table>p>span{display:block;font-size:16px;}
.mcd-meta-table>p>span:last-child{color:#8492a6;font-size:12px;margin-top:4px;}

.mcd-design-preview{padding:9px;margin:10px;border:1px solid #ebebeb;background:#fafafa;border-radius:8px;overflow:scroll;}
.mcd-design-preview span{color:blue;}
.mcd-design-preview p{color:#333;}
.mcd-design-area{position:relative;height:360px;margin:10px;border:1px solid #ebeef5;border-radius:8px;user-select:none;}
.mcd-design-table{position:absolute;text-align:center;cursor:pointer;box-shadow:2px 2px 19px #aaa;border-radius:8px;width:160px;height:40px;line-height:40px;transition:box-shadow 0.15s ease-in;box-sizing:border-box;}
.mcd-design-table:hover{box-shadow:2px 2px 19px #444;opacity:0.9;}
.mcd-design-label{color:#606266;box-shadow:2px 2px 19px #444;background:#fff;border-radius:4px;padding:4px;cursor:pointer;}
.mcd-design-column{margin:10px;border:1px solid #ebeef5;border-bottom:0;}
.mcd-connection-type .el-select{width:260px;margin-left:10px;}
.jtk-connector,.jtk-endpoint{cursor:pointer}
</style>
